import { render, staticRenderFns } from "./CampaignDateForm.vue?vue&type=template&id=a84e5e82&scoped=true&"
import script from "./CampaignDateForm.vue?vue&type=script&lang=js&"
export * from "./CampaignDateForm.vue?vue&type=script&lang=js&"
import style0 from "./CampaignDateForm.vue?vue&type=style&index=0&id=a84e5e82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84e5e82",
  null
  
)

export default component.exports